import { GeoJSONDataSource, Polygon } from 'mapv-three';
import { arrify } from '../arrify';

export class Pillar {
  constructor({ engine, polygonOpts, size, prop }) {
    this.data = [];

    this.engine = engine;

    this.size = size || 10; // 每个格子的大小
    this.scale = 1;

    // this.scale = 0.0000089;

    this.prop = prop;

    this.init(polygonOpts);
  }

  init(polygonOpts) {
    this.params = Object.assign(
      {
        extrude: true, // 是否拉伸
        vertexColors: true,
        vertexHeights: true,
        opacity: 0.8
      },
      polygonOpts
    );

    this.polygon = new Polygon(this.params);

    this.engine.add(this.polygon);

    return this;
  }

  calcParamsByData() {
    if (!this.data.length) return;

    // 计算位置范围
    const positions = this.data.map(e => this.engine.map.projectPointArr(e.position));
    let minX, minY, minZ, maxX, maxY, maxZ;

    for (let i = 0; i < positions.length; i++) {
      const [x, y, z] = positions[i];
      if (i === 0) {
        minX = maxX = x;
        minY = maxY = y;
        minZ = maxZ = z;
      } else {
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
        minZ = Math.min(minZ, z);
        maxZ = Math.max(maxZ, z);
      }
    }

    this.minX = minX;
    this.maxX = maxX;
    this.minY = minY;
    this.maxY = maxY;
    this.minZ = minZ;
    this.maxZ = maxZ;

    this.xPiece = this.size * this.scale;
    this.yPiece = this.size * this.scale;

    this.width = this.maxX - this.minX;
    this.height = this.maxY - this.minY;

    this.xCount = Math.ceil(this.width / this.xPiece) + 1;
    this.yCount = Math.ceil(this.height / this.yPiece) + 1;

    this.fullWidth = this.xCount * this.xPiece;
    this.fullHeight = this.yCount * this.yPiece;

    this.left = this.minX - (this.fullWidth - this.width) / 2;
    this.top = this.minY - (this.fullHeight - this.height) / 2;

    return this;
  }

  draw() {
    if (this.data.length < 1) return;

    this.calcParamsByData();

    const map = {};

    let x, y, key;

    this.data.forEach(e => {
      [x, y] = this.engine.map.projectPointArr(e.position);

      x = Math.floor((x - this.left) / this.xPiece);
      y = Math.floor((y - this.top) / this.yPiece);
      key = `${x}-${y}`;

      if (map[key]) {
        if (map[key][this.prop] > e[this.prop]) return;
      }

      map[key] = e;
    });

    if (!this.dataSource) {
      this.initDataSource(map);
    } else {
      this.dataSource.setData(this.makeGeoJson(map));
    }
  }

  makeGeoJson(data) {
    const geojson = {
      type: 'FeatureCollection',
      features: []
    };

    const features = Object.keys(data).map(key => {
      const e = data[key];

      return {
        type: 'Feature',
        geometry: {
          type: 'MultiPolygon',
          coordinates: [[this.makeCoordinates(key)]]
        },
        properties: {
          color: e.color,
          height: e.height || 10
        }
      };
    });

    geojson.features = features;

    return geojson;
  }

  makeCoordinates(key) {
    const pos = key.split('-');

    const boundary = [
      [0, 0],
      [1, 0],
      [1, 1],
      [0, 1],
      [0, 0]
    ];

    const arr = [this.left, this.top];
    const pieces = [this.xPiece, this.yPiece];

    const edges = boundary
      .map(e => {
        return e.map((item, index) => arr[index] + (+pos[index] + item) * pieces[index]);
      })
      .map(e => this.engine.map.unprojectPointArr(e));

    return edges;
  }

  async initDataSource(map) {
    const dataSource = await GeoJSONDataSource.fromGeoJSON(this.makeGeoJson(map));

    dataSource.setAttribute('color');
    dataSource.setAttribute('height');

    this.polygon.dataSource = dataSource;
    this.dataSource = dataSource;

    return this;
  }

  addData(data) {
    data = arrify(data);

    this.data.push(...data);
  }

  setData(data) {
    this.data = arrify(data);

    this.draw();
  }

  useProp(prop) {
    this.prop = prop;
  }

  setVisible(val) {
    this.polygon.visible = val;
  }

  dispose() {
    this.data = [];
    this.engine.remove(this.polygon);
    this.dataSource?.dispose();
    this.polygon.dispose();
  }
}
